import { call, put, takeEvery } from "redux-saga/effects";
import { FETCH_LINK_BY_TOKEN, VALIDATE_LINK_BY_TOKEN, CREATE_LINK} from "./actionTypes";
import {
  fetchLinkByTokenFailure,
  fetchLinkByTokenSuccess,
  validateLinkByTokenSuccess,
  validateLinkByTokenFailure,
  createLinkSuccess,
  createLinkFailure,
} from "./action";
import {
  validateAndGetLink,
  validateAndGetLinkPublic,
  validateLinkPublic,
  createLink,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";

function* workFetchLinkByToken(action) {
  const { navigate, linkRequest, type } = action.payload;
  try {
    let response;
    if (type === "public") {
      response = yield call(validateAndGetLinkPublic, linkRequest);
    } else {
      response = yield call(validateAndGetLink, linkRequest);
    }
    yield put(fetchLinkByTokenSuccess(response?.data));
    if (response?.data && response?.data?.url) {
      navigate(response?.data?.url, {
        state: { linkToken: linkRequest?.token },
      });
    } else {
      if (type === "public") {
        toast.error("Invalid link token");
        navigate("/job-portal/home");
      } else {
        toast.error("Invalid link token");
        navigate("/dashboard");
      }
    }
  } catch (error) {
    yield put(fetchLinkByTokenFailure(error));
    toast.error("Invalid link token");
    navigate("/dashboard");
  }
}

function* workValidateLinkByToken(action) {
  const { navigate, linkRequest, setPageLoading } = action.payload;
  try {
    const response = yield call(validateLinkPublic, linkRequest);
    yield put(validateLinkByTokenSuccess(response?.data));
    setPageLoading(false);
  } catch (error) {
    yield put(validateLinkByTokenFailure(error));
    toast.error("Invalid link token");
    navigate("/job-portal/home");
  }
}

function* workCreateLink(action) {
  const { linkRequest, setGeneratedLink} = action.payload;
  try {
    const response = yield call(createLink, linkRequest);
    yield put(createLinkSuccess(response?.data));
    const token = response?.data?.token;
    setGeneratedLink(`/public?rq=${token}`);
  } catch (error) {
    yield put(createLinkFailure(error));
    toast.error("Failed to create link");
  }
}

export default function* watchFetchAccountContactsSaga() {
  yield takeEvery(FETCH_LINK_BY_TOKEN, workFetchLinkByToken);
  yield takeEvery(VALIDATE_LINK_BY_TOKEN, workValidateLinkByToken);
  yield takeEvery(CREATE_LINK, workCreateLink);
}
